export default {
    path: 'exhibitions',
    name: 'ExhibitionForm',
    component() {
        return import('@/components/exhibition/ExhibitionForm.vue')
    },
    children: [
        {
            path: '',
            name: 'ExhibitionList',
            component() {
                return import('@/components/exhibition/exhibition/ExhibitionList.vue')
            },
        },
        {
            path: ':id',
            name: 'ExhibitionDetail',
            component() {
                return import('@/components/exhibition/exhibition/ExhibitionDetail.vue')
            },
        },
        {
            path: 'toBePub',
            name: 'ExhibitionToBePubList',
            component() {
                return import('@/components/exhibition/exhibitionToBePub/ExhibitionToBePubList')
            },
        },
        {
            path: 'toBePub/:id',
            name: 'ExhibitionToBePubDetail',
            component() {
                return import('@/components/exhibition/exhibitionToBePub/ExhibitionToBePubDetail.vue')
            },
        },
    ],
}